export function formatCurrencyForDisplay(value = 0) {
    const hasDecimal = value % 1 !== 0;
    return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: hasDecimal ? 2 : 0,
        maximumFractionDigits: hasDecimal ? 2 : 0,
    }).format(value);
}
